import { render, staticRenderFns } from "./StudyQuizMainTemplate.vue?vue&type=template&id=6c5e5aa0"
import script from "./StudyQuizMainTemplate.vue?vue&type=script&lang=js"
export * from "./StudyQuizMainTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports